<!--==============================
=            SETTINGS            =
===============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Settings</div>
      </base-header>
    </v-row>




    <v-row>  
    <v-col cols="12" md="12" sm="12">
        <base-card>
          <div slot="card-header">   Settings User </div>
           <div slot="card-subheader">  Excepteur culpa
                  ad culpa veniam fugiat aute culpa qui eiusmod minim occaecat cupidatat cillum. </div>
            <div slot="card-body"> 
           
            <v-data-table          
                          :headers="headers"
                          :items="desserts"
                          :items-per-page="5"
                          class="elevation-0 black--text">
              <template v-slot:item.email="{ item }">
                <v-switch v-model="item.email"
                          inset></v-switch>
              </template>
              <template v-slot:item.push="{ item }">
                <v-switch v-model="item.push"
                          inset></v-switch>
              </template>
              <template v-slot:item.sms="{ item }">
                <v-switch v-model="item.sms"
                          inset></v-switch>
              </template>

            </v-data-table>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <base-card>
          <div slot="card-header">

            Configurations
          </div>
          <div slot="card-subheader">Irure quis incididunt ipsum laborum sint id. Tempor tempor qui ipsum aliquip
            cillum. Ad aliquip excepteur do dolore amet. Veniam ullamco fugiat reprehenderit deserunt.</div>
          <div slot="card-body">
            <v-tabs   :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'"  vertical>
          
              <v-tab class="transparent">
                <v-icon left>
                  apps

                </v-icon>
                Security
              </v-tab>
              <v-tab class="transparent">
                <v-icon left>
                  assignment_ind

                </v-icon>
                Profile
              </v-tab>


              <v-tab-item>
               
                  <card-security></card-security>
              
              </v-tab-item>
              <v-tab-item>
                
                  <card-information></card-information>
               
              </v-tab-item>

            </v-tabs>
          </div>
        </base-card>
      </v-col>
     
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  import CardInformation from '../../components/Cards/CardInformation'
  import CardSecurity from '../../components/Cards/CardSecurity'
  export default {
    components: {
      BaseCard,
      BaseHeader,
      CardInformation,
      CardSecurity
    },
    data() {
      return {
        otp: '',
        selectedItem: 1,
        phone:'',
        items: [{
            title: 'Settings',
            icon: 'mdi-view-dashboard'
          },
          {
            title: 'Privation',
            icon: 'mdi-image'
          },
          {
            title: 'Notifications',
            icon: 'help_outline'
          },
          {
            title: 'Confirmations',
            icon: 'settings'
          },
          {
            title: 'Password requirements',
            icon: 'lock'
          },
          {
            title: 'Task',
            icon: 'check_circle_outline'
          },
          {
            title: 'News',
            icon: 'receipt'
          },
          {
            title: 'Social',
            icon: 'verified'
          },
          {
            title: 'Accounts',
            icon: 'article'
          },

        ],
        headers: [{
            text: 'Activity',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'Push',
            value: 'push'
          },
          {
            text: 'SMS',
            value: 'sms'
          },

        ],
        desserts: [{
            name: 'Mentions',
            email: true,
            push: true,
            sms: false,

          },
          {
            name: 'Comments',
            email: false,
            push: false,
            sms: false,

          },
        
         

        ],
        selection: 0,
      }
    },

  }
</script>

<style>
  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }  .card-dark {
    border-radius: 1em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
    background: rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>


<!--====  End of SETTINGS  ====-->
